import { render, staticRenderFns } from "./SfxIconArrowRight.vue?vue&type=template&id=fa05cd28&"
import script from "./SfxIconArrowRight.vue?vue&type=script&lang=js&"
export * from "./SfxIconArrowRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports